import React from 'react';
import {
  createStackNavigator,
  NavigationActions,
  StackActions,
} from 'react-navigation';
import { withBrowserHistory } from 'react-navigation-browser-history-helpers';
import { DRNUtil } from '@traveloka/district-util';

import { mainRoutes } from './routes';
import R from './common/res/R';
import HeaderMoreMenu from 'common/components/HeaderMoreMenu/HeaderMoreMenu';
import ServiceWorkerNotification from 'common/components/ServiceWorkerNotification/ServiceWorkerNotification';
import TOSLogo from 'common/res/svg/TosLogo';

const MainNavigator = createStackNavigator(mainRoutes, {
  headerLayoutPreset: 'center',
  navigationOptions: ({ navigation }) => ({
    headerTitle: TOSLogo,
    headerRight: (
      <React.Fragment>
        <ServiceWorkerNotification />
        <HeaderMoreMenu navigation={navigation} />
      </React.Fragment>
    ),
    headerStyle: {
      backgroundColor: R.color.brand,
    },
    headerRightContainerStyle: {
      marginRight: R.spacing.m,
    },
    headerTintColor: R.color.uiLightPrimary,
  }),
});

const AppNavigator = withBrowserHistory(MainNavigator);

const defaultGetStateForAction = AppNavigator.router.getStateForAction;
AppNavigator.router.getStateForAction = (action, state) => {
  // When navigate to other page, attempt to update SW
  const isNavigateAction =
    action.type === NavigationActions.INIT ||
    action.type === NavigationActions.NAVIGATE ||
    action.type === NavigationActions.BACK ||
    action.type === StackActions.POP ||
    action.type === StackActions.PUSH;

  const isUpdateSWReady =
    DRNUtil.isWeb() &&
    typeof window !== 'undefined' &&
    window.__UPDATE_SERVICE_WORKER__;

  if (isNavigateAction && isUpdateSWReady) {
    window.__UPDATE_SERVICE_WORKER__();
  }

  // return default react-navigation behaviour
  return defaultGetStateForAction(action, state);
};

export default AppNavigator;
